module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_8.d68a2b1c.jpg";